module.exports = __webpack_public_path__ + "img/red-square.5a997178.svg";